import {
  ActiveUserAPI,
  FeatureFlagsAPI,
  FeatureFlagsType,
  SettingsAPI,
  SettingsType,
  UserType,
} from 'src/api';
import { AlertType } from 'src/components';

export interface ContextFragment {
  alerts: AlertType[];
  featureFlags: FeatureFlagsType;
  groupAccessDenied?: boolean;
  settings?: SettingsType;
  user?: UserType;
}

export function loadContext(): Promise<ContextFragment> {
  const getFeatureFlags = FeatureFlagsAPI.get().then(
    ({ data: featureFlags }) => ({
      alerts: (featureFlags._messages || []).map((msg) => ({
        variant: 'warning',
        title: msg.split(':')[1],
      })),
      featureFlags,
    }),
  );

  return Promise.all([
    ActiveUserAPI.getUser(),
    SettingsAPI.get(),
    getFeatureFlags,
  ])
    .then(([user, { data: settings }, { alerts, featureFlags }]) => ({
      alerts,
      featureFlags,
      settings,
      user,
    }))
    .catch((e) => {
      // Check if the backend denied access due to missing group membership
      // (RequiredGroupMiddleware returns 403 with code "access_denied").
      const isGroupAccessDenied =
        e?.response?.status === 403 &&
        e?.response?.data?.errors?.some((err) => err.code === 'access_denied');

      // we need this even if ActiveUserAPI fails, otherwise isExternalAuth will always be false, breaking keycloak redirect
      return getFeatureFlags
        .then(({ alerts, featureFlags }) => ({
          alerts,
          featureFlags,
          ...(isGroupAccessDenied && { groupAccessDenied: true }),
        }))
        .catch(() => ({
          alerts: [] as AlertType[],
          featureFlags: {} as FeatureFlagsType,
          ...(isGroupAccessDenied && { groupAccessDenied: true }),
        }));
    });
}
